import {
  ComplaintsCategoriesDocument,
  UpdateComplaintsCategoryDocument,
  UpdateComplaintsCategoryMutation,
  UpdateComplaintsCategoryMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateComplaintsCategory = () => {
  const [executeMutation] = useMutation(UpdateComplaintsCategoryDocument, {
    extractorFn: (data: UpdateComplaintsCategoryMutation) =>
      data.complaintsMutations.updateComplaintsCategory,
  })

  const updateComplaintsCategory = async (variables: UpdateComplaintsCategoryMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [ComplaintsCategoriesDocument],
    })
  }

  return {
    updateComplaintsCategory,
  }
}
